const initialState = {
  isLoggedIn: false,
  TokenPayload: {},
  accessToken: "",
  token: null,
  loginRequired: false,
  refreshing: false,
  loginLoading: false,
  refreshToken: null,
  savePath: null,
  overlayLoading: false,
  isAuthenticated: false,
  abortController: {},
  isRegister: false,
  isConfirm: false,
  uuid: "",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOAD_REFRESH":
      return { ...state, refreshing: true };

    case "LOGIN_SUCCESS":
      return {
        ...state,
        accessToken: action.payload.accessToken,
        TokenPayload: action.payload.tokenPayload,
        refreshToken: action.payload.refresh_token,
        isAuthenticated: true,
        loginRequired: false,
        isLoggedIn: true,
      };

    case "REGISTER_SUCCESS":
      return {
        ...state,
        isRegister: action.payload,
      };

    case "EMAIL_CONFIRM":
      return {
        ...state,
        isConfirm: action.payload,
      };

    case "REFRESHING_TOKEN":
      return {
        ...state,
        isLoggedIn: true,
        accessToken: action.accessToken,
        refreshing: false,
        TokenPayload: action.payload,
        isAuthenticated: true,
      };

    case "LOGOUT":
      return initialState;

    case "LOGIN_LOADING":
      return { ...state, loginLoading: action.payload };

    case "OVERLAY_LOADING":
      return { ...state, overlayLoading: action.payload };

    case "LAUNCH_MODAL_LOGIN":
      return { ...state, loginRequired: action.payload };

    case "SAVE_CURRENT_PATH":
      return { ...state, savePath: action.payload };

    case "TRANSACTION_UUID":
      return { ...state, uuid: action.payload };

    case "ABORT":
      return {
        ...state,
        abortController: {
          ...state.abortController,
          [action.name]: new AbortController(),
        },
      };

    default:
      return state;
  }
};

export default authReducer;
